var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc-layer-background",class:_vm.classBackground},[_c('div',{staticClass:"tc-layer-background-now",style:(_vm.styleNow)})])}
var staticRenderFns = []

export { render, staticRenderFns }